// MIT License. See license.txt

// for translation
platia_tech._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = platia_tech._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = platia_tech._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = platia_tech._;

platia_tech.get_languages = function () {
	if (!platia_tech.languages) {
		platia_tech.languages = [];
		$.each(platia_tech.boot.lang_dict, function (lang, value) {
			platia_tech.languages.push({ label: lang, value: value });
		});
		platia_tech.languages = platia_tech.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return platia_tech.languages;
};
